import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

import { AlertButton, AlertInput } from '@/helpers/alert-helper-vfm';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertModal',
  props: {
    header: null,
    subHeader: { default: '' },
    message: { default: '' },
    buttons: { default: () => [] },
    inputs: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { header: string, subHeader: string, message: string, buttons: AlertButton[], inputs: AlertInput[] };



const inputsData = ref<AlertInput[]>(
	props.inputs.map(input => (input.name ? { ...input, value: input.value ?? '' } : input))
);

watch(
	() => props.inputs,
	newInputs => {
		inputsData.value = newInputs.map(input => (input.name ? { ...input, value: input.value ?? '' } : input));
	},
	{ deep: true }
);

function onClick(btn: AlertButton) {
	const inputValues = Object.fromEntries(
		inputsData.value
			.map(i => [i.name?.trim(), typeof i.value === 'string' ? i.value.trim() : i.value] as const)
			.filter(([k, v]) => !!k && v != null)
	);

	if (btn.handler) {
		Object.keys(inputValues).length > 0 ? btn.handler(inputValues) : btn.handler();
	}
}

return { __sfc: true,props, inputsData, onClick }
}

})